import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Logger from "dce-logger/lib/logger/Logger";
import OpenDialog from "./modal/OpenDialog";

interface AppendableSubformProps {
    minLength: number,
    maxLength: number
    inputName: string
}

@Dce("AppendableSubform")
export default class AppendableSubform extends DceComponent<AppendableSubformProps> {

    protected logger = Logger.of("AppendableSubform");

    protected block: JQuery<HTMLElement>;

    protected itemsBlock: JQuery<HTMLElement>;

    protected prototype: string;

    protected name: string;

    constructor(elem: DceHTMLElement, props: AppendableSubformProps) {
        super(elem, props);

        this.name = props.inputName;

        this.block = $(elem);
        this.itemsBlock = this.block;

        let items = this.block.find('*[role=items]');
        if(items.length > 0) {
            this.itemsBlock = items.first();
        }

        let protoElement = this.block.find('*[role=prototype]').first();
        this.prototype = protoElement.text();
        protoElement.remove();

    }

    public add(){
        //add new item
        var next = this.nextIndex();
        let form = $(this.createNextSubform(next));

        form.attr('role', 'item')
            .data('index', next)
            .attr('data-index', next);

        this.itemsBlock.append(form);
    }

    public addItem(html: string){
        //add new item
        var next = this.nextIndex();
        let form = $(html);

        form.attr('role', 'item')
            .data('index', next)
            .attr('data-index', next);

        this.itemsBlock.append(form);
        this.renumber();
    }

    public remove(e:Event){
        //remove closest
        let target = e.target as Element;

        let item = $(target).closest('*[role=item]');
        item.remove();
        this.renumber();
    }

    public moveUp(e:Event){
        //remove closest
        let target = e.target as Element;

        let item = $(target).closest('*[role=item]');

        let prevItem = item.prev('*[role=item]');

        if(prevItem.length  > 0 ){
            item.insertBefore(prevItem);
        }

        this.renumber();
    }

    public moveDown(e:Event){
        //remove closest
        let target = e.target as Element;

        let item = $(target).closest('*[role=item]');

        let nextItem = item.next('*[role=item]');

        if(nextItem.length  > 0 ){
            item.insertAfter(nextItem);
        }

        this.renumber();
    }

    protected renumber() {

        let items = this.itemsBlock.find('*[role=item]');

        items.each((i, e) => {

            let name = this.name;
            let item = $(e);

            item.attr('data-index', i);
            item.data('index', i);

            var newid = name + '_' + i;
            var newname = name + '[' + i + ']';

            if(item.attr('id') && item.attr('id').indexOf(name) == 0){
                item.attr('id', item.attr('id').replace(new RegExp(name + '_\\d+',''), newid));
            }

            item.find('input, div, select, fieldset').each(function(){

                if($(this).attr('id') && $(this).attr('id').indexOf(name) == 0){
                    $(this).attr('id', $(this).attr('id').replace(new RegExp(name + '_\\d+',''), newid));
                }

                if($(this).attr('name') && $(this).attr('name').indexOf(name) == 0){
                    $(this).attr('name', $(this).attr('name').replace(new RegExp(name + '\\[\\d+\\]', ''), newname));
                }

            });

            item.find('label').each(function(){

                if($(this).attr('for') && $(this).attr('for').indexOf(name) == 0){
                    $(this).attr('for', $(this).attr('for').replace(new RegExp(name + '_\\d+',''), newid));
                }

            });

        })


    }

    private nextIndex(): number {
        let index = -1;

        this.itemsBlock.find('*[role=item]').each(function(i, element){
            if(parseInt($(element).data('index')) > index){
                index = $(element).data('index');
            }
        });

        return ++index;
    };

    private createNextSubform(nextIndex:number):string{
        let proto = this.prototype;
        var form = proto.replace(
            new RegExp('{{PROTOTYPE}}', 'g'), nextIndex + ""
        );
        return form;
    }


    onSubComponentInit(component: string, elem: DceHTMLElement) {
        if(component === 'OpenDialog'){

            console.log("Appendable subform SUBCOMPONENT INIT!!!!", this.elem);

            if(elem.hasAttribute('role') && elem.getAttribute('role') == 'appendFromDialog'){

                let openDialog = elem.ext.getComponent(component) as OpenDialog;

                openDialog.addOnClose((d,e) => {

                    this.logger.debug("CLOSING DIALOG FORM TO APPEND");

                    if(d.getFormSaved()){

                        if(d.getFormResponse().hasResponse()){
                            let newitem = d.getFormResponse().response;
                            this.addItem(newitem);

                        }

                    }
                });
            }
        }

    }

    defaultProps(): Partial<AppendableSubformProps> {
        return {
            minLength: 0,
            maxLength: 100,
            inputName: ""
        }
    }
}
